import {useEffect} from 'react';

import {
  Conversation,
  InlineDataAction,
} from '@stripe-internal/conversations-client';
import {useInlineDataEvents} from '@stripe-internal/inline-data';

import {buildUHConversationIssueContext} from '../lib/util/conversationUtils';
import {useApp} from './appHooks';

export function useConversationInlineDataEvents(
  conversation?: Conversation | null,
) {
  const inlineDataEvents = useInlineDataEvents();
  const app = useApp();
  useEffect(() => {
    if (!conversation) {
      return;
    }

    const sub = inlineDataEvents.observable.subscribe((event) => {
      if (event.name === 'inline-data-action') {
        const actionEvent = event as InlineDataAction;
        app.analytics.action('inline_data_action', {
          conversationId: conversation.id,
          stage: 'action_received',
        });

        const handleAction = async () => {
          try {
            const resp = await conversation.action(actionEvent);
            app.analytics.action('inline_data_action', {
              conversationId: conversation.id,
              stage: resp.error
                ? 'action_resolved_error'
                : 'action_resolved_success',
            });
            inlineDataEvents.emit({
              name: 'inline-data-action-result',
              data: event.data,
              nonce: event.nonce,
              code: resp.code,
              error: resp.error,
            });
          } catch {
            app.analytics.action('inline_data_action', {
              conversationId: conversation.id,
              stage: 'action_rejected',
            });
            inlineDataEvents.emit({
              name: 'inline-data-action-result',
              data: event.data,
              nonce: event.nonce,
              code: 500,
              error: 'unexpected_error',
            });
          }
        };

        handleAction();
      }

      if (event.name === 'inline-data-channel-form-initial-message') {
        inlineDataEvents.emit({
          name: 'inline-data-channel-form-initial-message-result',
          data: {
            initialMessage: conversation.context.latestQuestion || '',
          },
          nonce: event.nonce,
        });
      }

      if (event.name === 'inline-data-trigger-scroll-to-top') {
        conversation.triggerScrollToTop();
      }
      if (event.name === 'inline-data-channel-form-issue-context') {
        inlineDataEvents.emit({
          name: 'inline-data-channel-form-issue-context-result',
          data: {
            issueContext: buildUHConversationIssueContext(conversation),
          },
          nonce: event.nonce,
        });
      }
    });
    return () => sub.unsubscribe();
  }, [app, conversation, inlineDataEvents]);
}
